import React from "react";
import AdvancedFilterDrawer from "./AdvanceFilterDrawer";

const AdvanceFilterComponent = ({
  advanceFilter,
  setAdvanceFilter,
  editFilter,
  setEditFilter,
  selectedFilter,
  setSelectedFilter,
  fetchFilters,
  onFilterChange,
  isPublic,
  setIsPublic,
  filters,
  setFilters,
  attribute_set_key,
  filterName,
  setFilterName,
  columnsDef,
}) => {
  const showAdvFilter = () => {
    setAdvanceFilter((prev) => !prev);
    if (!editFilter) {
      setSelectedFilter(null);
    }
  };

  const condition =
    filters && filters.length > 0 && filters[0] && filters[0].condition;

  const isKnownCondition =
    condition === "is_known" || condition === "not_known";

  const hasFilterValue =
    !selectedFilter &&
    Array.isArray(filters) &&
    filters.length > 0 &&
    (isKnownCondition ||
      (filters[0].value !== undefined &&
        filters[0].value !== null &&
        filters[0].value.toString().trim() !== ""));

  return (
    <React.Fragment>
      <div
        id="toggle-btnf"
        style={{
          height: "37px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        className={`toggle-btn ${advanceFilter ? " collapse-state" : ""} ${hasFilterValue ? "f-active" : ""}`}
        onClick={() => showAdvFilter()}
      >
        <svg
          width="20"
          height="17"
          viewBox="0 0 20 17"
          fill="#006efa"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.83333 12.5H11.1667V11.3571H7.83333V12.5ZM4.5 9.07143H14.5V7.92857H4.5V9.07143ZM2 4.5V5.64286H17V4.5H2Z"
            fill="#303049"
          ></path>
        </svg>
        <span className="ml-2">Advanced Filter</span>
      </div>
      <AdvancedFilterDrawer
        open={advanceFilter}
        columnsDef={columnsDef}
        onClose={() => setAdvanceFilter(false)}
        onFilterChange={onFilterChange}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        fetchFilters={fetchFilters}
        editFilter={editFilter}
        setEditFilter={setEditFilter}
        isPublic={isPublic}
        setIsPublic={setIsPublic}
        filters={filters}
        setFilters={setFilters}
        attribute_set_key={attribute_set_key}
        filterName={filterName}
        setFilterName={setFilterName}
      />
    </React.Fragment>
  );
};

export default AdvanceFilterComponent;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/AdvanceFilterComponent.js